<div [hidden]="!allowMetrics">
  <!-- <div style="max-width:800px; display:flex; flex-direction: row; align-content: space-between; justify-content: space-between; gap:5%;">
        <div style="flex:1;">
            <app-transactions-chart chartType="bar" [merchantId]="this.merchantId" ></app-transactions-chart>
        </div>

        <div style="flex:1;">
            <app-revenue-chart chartType="line" [merchantId]="this.merchantId" ></app-revenue-chart>
        </div>
    </div> -->
  <!--
    <div style="display:flex; flex-direction: row; align-content: space-between; justify-content: space-between; margin-bottom:20px;" *ngIf="allowMyTransactions">
        <div style="flex:1;">
            <div class="sectionContainer paddedContent">

                <h2>Recent transactions</h2>

                <app-filterable-table #transactionsTable [tableView]="transactionsTableView"
                    (selectedRecord)="handleTransactionSelected($event)"></app-filterable-table>
            </div>                
        </div>
    </div>
--></div>

<app-filterable-table
  #transactionsTable
  [hidden]="selectedTransaction != undefined"
  [tableView]="tableView"
  [options]="transactionTableOptions"
  [initialPageSize]="10"
>
</app-filterable-table>
